import { bindData } from "@aelive/data-binding-library";

// Builds one ADVANCED tile from its caption payload and the live fixture.
export async function resolveAdvancedTile(entry, payload, context) {
  const tile = { key: entry.name, name: entry.name, kind: entry.kind, title: entry.title };
  if (entry.kind === "title" || !payload) return tile;

  const { output } = await bindData(payload, context);
  if (entry.kind === "twoWay") {
    const threat = output?.AttackingThreat;
    return { ...tile, home: threat?.Team1?.iBarScale ?? "0", away: threat?.Team2?.iBarScale ?? "0" };
  }
  const win = output?.WinProbability;
  return {
    ...tile,
    values: [win?.Team1?.strValue, win?.Draw?.strValue, win?.Team2?.strValue].map((v) => v ?? "0"),
    labels: ["Win", win?.Draw?.strTitle || "Draw", "Win"],
  };
}
